<div id="toggle-partial-shift" *ngIf="showToggle" class="time-format-toggle" fxLayout="row" fxLayoutAlign="start center"
    fxLayoutGap="5px" fxFlexOffset="20px">
    <label [ngClass]="{'disabled' : checkedToggle}">AM</label>
    <mat-slide-toggle automation-id="shift-type-start-format" (change)="checkToggle($event)"></mat-slide-toggle>
    <label [ngClass]="{'disabled': !checkedToggle}">PM</label>
</div>